import { Button, Link, Stack, Text } from "basis";
import { ActionType, ScreenProps } from "./types";

export const VerifierTerms = ({ dispatch }: ScreenProps) => (
  <Stack gap="8">
    <Text textStyle="heading4">Verifier's terms of service</Text>
    <Text>
      You agree Verifier Australia Pty Ltd (<strong>us, we, our</strong>) may,{" "}
      <strong>on your behalf</strong>, request access to data that organisations
      hold about your superannuation contributions, payroll and employer. This
      request is made using YOUR right of access to your personal information.
      Your right arises under the Privacy Act.
    </Text>
    <Text>
      You also agree that we may use and disclose that data to calculate your
      income and give the lender a response about your income and employment.
      You can ask your lender to give you access to the data that we obtained on
      your behalf. More information about how we use, disclose and store your
      data is set out in the{" "}
      <Link href="https://www.verifier.me/privacy" newTab>
        Verifier Privacy Policy
      </Link>
      .
    </Text>
    <Text>
      To enable us to find the data about you, your lender will give us your
      name, address, mobile number, email address and date of birth (as provided
      by you in your credit application) and may also obtain your prior
      addresses from your credit report and give them to us.
    </Text>
    <Button
      width="192"
      onClick={() => {
        dispatch({
          type: ActionType.VERIFIER_TERMS_BACK_CLICKED,
        });
      }}
    >
      Back
    </Button>
  </Stack>
);
